"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIngredientListQuery = void 0;
const client_1 = require("@apollo/client");
exports.getIngredientListQuery = client_1.gql `
  query GetIngredientList {
    getIngredientList
  }
`;
//# sourceMappingURL=GetIngredientList.js.map